import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getMAWBInfoList(params) {
  return request({
    url: URL.partner.mawbInfo,
    method: 'get',
    params
  })
}

export function saveMAWBInfo(data) {
  return request({
    url: URL.partner.mawbInfo,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delMAWBInfo(uuid) {
  return request({
    url: URL.partner.mawbInfo + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

export function queryMAWBInfo(params) {
  return request({
    url: URL.partner.queryMAWBInfo,
    method: 'get',
    params: params
  })
}
